import React, { SetStateAction, useState, ChangeEvent } from 'react';
import Radio from '../Radio/Radio';

import './Reattribution.scss';

const OPERATIONS = {
    REATTRIBUTION: 'reattribution',
    REUPLOAD: 'reupload',
};

function Reattribution({ setReattribution }: { setReattribution: (event: SetStateAction<boolean>) => void }) {
    const [value, setValue] = useState(OPERATIONS.REUPLOAD);
    const onChange = (e: ChangeEvent<Element>) => {
        const data = e.target.getAttribute('value');
        setReattribution(data === OPERATIONS.REATTRIBUTION);
        setValue(data as string);
    };
    return (
        <>
            <Radio onChange={onChange} value={OPERATIONS.REUPLOAD} selectedValue={value} label="RE-UPLOAD" />
            <Radio onChange={onChange} value={OPERATIONS.REATTRIBUTION} selectedValue={value} label="RE-ATTRIBUTE" />
        </>
    );
}

export default Reattribution;
